/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcProspectusV1ProspectusTaskState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PROSPECTUS_V1_PROSPECTUS_TASK_STATE_ENTITY_NAME = 'ixc.prospectus.v1.ProspectusTask';
export const ixcProspectusV1ProspectusTaskStateEntity = new schema.Entity<IxcProspectusV1ProspectusTaskState>(IXC_PROSPECTUS_V1_PROSPECTUS_TASK_STATE_ENTITY_NAME, {}, { idAttribute: 'taskId' });

